module.exports = __webpack_public_path__ + "static/media/duke.787394d6.png";